module.exports = __webpack_public_path__ + "media/images/news/bg04-db2e529a32ffb0a3b78251c80dd416d5.png";